import {useState, useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import exportFileType from 'shared/lib/fileTypeExtractor'

// origin: string[] ( 초기 값 )
// limit: integer ( 리스트 길이 제한 )
const usePostImgListUpload = (origin, limit = 0) => {
	const [imgState, setImgState] = useState([])
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		origin && setImgState(origin)
	}, [origin])

	const setImg = (e) => {
		const file = e.target.files[0]

		if (imgState.length >= limit)
			setAlert(`${limit}개 이하의 이미지만 업로드 가능합니다.`)
		else if (!file) setAlert('이미지가 선택되지 않았습니다.')
		else if (!['jpg', 'png'].includes(exportFileType(file.name).toLowerCase()))
			setAlert('jpg, png 이미지만 업로드 가능합니다.')
		else if (Math.round(file.size) > 10 * 1024 * 1024)
			setAlert('10MB 이하 이미지만 업로드 가능합니다.')
		else {
			const formdata = new FormData()
			formdata.append('src', file)

			let url = `/admin/util/upload`

			fetchRequest('POST', url, null, formdata)
		}
	}

	const deleteImg = (index) => {
		setImgState((state) => {
			const tmp = [...state]
			tmp.splice(index, 1)
			return tmp
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				setImgState((state) => [...state, fetchResult?.data?.path])
				break
			case 400:
				if (fetchResult?.data?.error_code === 'src')
					setAlert('이미지의 확장자와 용량을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [imgState, setImg, deleteImg]
}

export default usePostImgListUpload
